import React, { useState, useEffect, useRef,useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { color, motion } from 'framer-motion';
import { useInView, useAnimation } from 'framer-motion';


import { Play } from 'lucide-react'
import '../styles/home.css';
import india from '../assets/images/shutterstock_2179380367.jpg'
import HQ from '../assets/images/HQ_header.svg'
import entrance from '../assets/images/entrance.JPG'
import main1 from '../assets/images/Bhagwati Products Limited.svg'
import main2 from '../assets/images/main_2.JPG'
import main3 from '../assets/images/main_3.JPG'
import main4 from '../assets/images/main_4.JPG'
import img2 from '../assets/images/DSC_2491.JPG';
import img3 from '../assets/images/DSC_2538.JPG';
import img4 from '../assets/images/SAG_5305.JPG';
import acer from '../assets/images/Acer1.jpg';
import ac from '../assets/images/AC.jpg';
import Smartwatch from '../assets/images/Smart.webp';
import Plastic from '../assets/images/Plastic.webp';
import Laptop from '../assets/images/Laptop.webp';
import LED from '../assets/images/LED.jpg';
import Mobile from '../assets/images/Mobile.png';
import TWS from '../assets/images/tws8.jpg';
import manu1 from '../assets/images/AZ8_7174.jpg'
import manu2 from '../assets/images/AZ8_6777.jpg'
import manu3 from '../assets/images/AZ8_7216.jpg'
import manu4 from '../assets/images/AZ8_7185.jpg'
import manu5 from '../assets/images/AZ8_6925.jpg'
import largeTimeline from '../assets/images/timeline.png'
import smallTimeline from '../assets/images/smalltimeline.png'
import heritage from '../assets/images/AZ8_7399.jpg'
import craftmanship from '../assets/images/AZ8_6925.jpg'
import { img } from 'framer-motion/m';
import slide1 from '../assets/images/AZ8_6578.jpg'
import { AnimatePresence} from 'framer-motion'

import { 
    Cpu, 
    Gauge, 
    Wind, 
    Zap,
    Weight,
    Globe,
    ChevronRight,
    Shield,
    Target,
    Award,
    Factory,
    ArrowRight,
    ChevronLeft
  } from 'lucide-react';
  
const divisions = [
  {
    icon: (
      <svg className="w-16 h-16 mx-auto mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
        <path d="M4 16V8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8" />
        <rect x="4" y="16" width="16" height="6" rx="2" />
      </svg>
    ),
    title: 'LED TV',
    link:'/led-manufacturing',
    description: 'Advanced LED television manufacturing with cutting-edge display technology and smart features for superior viewing experience.',
  },
  {
    icon: (
      <svg className="w-16 h-16 mx-auto mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
        <path d="M3 5h18" />
        <path d="M8 5V3h8v2" />
        <rect x="4" y="8" width="16" height="13" rx="2" />
      </svg>
    ),
    title: 'Mobile Phones',
    link:'/mobile',
    description: 'State-of-the-art mobile phone production incorporating the latest technologies and features for modern communication needs.',
  },
  {
    icon: (
      <svg className="w-16 h-16 mx-auto mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <line x1="8" y1="20" x2="16" y2="20" />
      </svg>
    ),
    title: 'Tablets',
    link:'/tablet',
    description: 'High-performance tablet manufacturing combining powerful computing capabilities with sleek, portable design.',
  },
  
];

  const images = [
    HQ, // Replace with your image paths
    main1,
  ];
  const StatisticCard = ({ number, label }) => (
    <div className="flex flex-col">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="flex items-baseline"
      >
        <span className="text-7xl font-bold">{number}</span>
        {label === "month" && <span className="text-sm text-gray-500 ml-1">{label}</span>}
      </motion.div>
      <span className="text-gray-500 text-sm uppercase tracking-wider mt-2">
        {label === "month" ? "POSTOPERATIVE FOLLOW-UP" : "REGROWTH RATE"}
      </span>
    </div>
  )
  
  const slides1 = [
    {
      image: heritage,
      heading: 'Bhagwati Products Limited',
      text: 'Your Trusted Partner from Concept Design to Product Manufacturing',
    },
    {
      image: HQ, // Replace with your second image
      heading: 'Bhagwati Products Limited',
      text: "India's first 2+N+3 Smart Hard Platfrom"
    
    },
  ];
  const categories = [
  {
    id: 1,
    title: "Personal Terminal",
    image: "/api/placeholder/400/600",
    link: "#"
  },
  {
    id: 2,
    title: "Smart Wearable",
    image: "/api/placeholder/400/600",
    link: "#"
  },
  {
    id: 3,
    title: "Home Terminal",
    image: "/api/placeholder/400/600",
    link: "#"
  },
  {
    id: 4,
    title: "Automotive Electronics",
    image: "/api/placeholder/400/600",
    description: "Smart travel that is safe, comfortable, and efficient",
    isFeature: true
  },
  {
    id: 5,
    title: "Commercial Devices",
    image: "/api/placeholder/400/600",
    link: "#"
  },
  {
    id: 6,
    title: "Data Center",
    image: "/api/placeholder/400/600",
    link: "#"
  }
];

const Card = ({ children, className = "", delay = 0 }) => (
    <motion.div 
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay }}
      className={`rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 ${className}`}
    >
      {children}
    </motion.div>
  );
  const fadeInUpVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: custom * 0.2 }
    })
  };
  const slides = [
    {
      image:manu4,
      text: "Advanced Manufacturing Capabilities",
      
    },
    {
      image: manu2,
      text: "Cost-Effective Solutions",
    },
    {
      image: manu3,
      text: "Supply Chain Excellence",
    },
    {
      image: manu1,
      text: "Quality Control & Testing",
    },
    {
      image: manu5,
      text: "Sustainability in Manufacturing",
    },
  ]
  
const Home = () => {
  

  const processSteps = [
    {
      title: "Uncompromising Quality",
      image: manu2,
      description:
        "Adhering to stringent quality standards and certifications, ensuring reliability and trust.",
    },
    {
      title: "Precision Craftsmanship",
      image: manu3,
      description:
        "Utilizing advanced machinery and expert techniques for flawless manufacturing.",
    },
    {
      title: "Award-Winning Innovation",
      image: manu4,
      description:
        "Recognized for groundbreaking designs and sustainable manufacturing practices.",
    },
  ]


  const steps = [
    {
      number: "1",
      title: "Scalable Manufacturing",
      description:
        "Capable of handling large-scale production without compromising on quality.",
    },
    {
      number: "2",
      title: "Global Operations",
      description:
        "Delivering products across continents through a robust supply chain.",
    },
    {
      number: "3",
      title: "Technologically Advanced",
      description:
        "Integrating AI and IoT for efficient and automated production workflows.",
    },
    {
      number: "4",
      title: "Sustainable Practices",
      description:
        "Implementing eco-friendly processes and materials to minimize environmental impact while maximizing efficiency.",
    },
    {
      number: "5",
      title: "Innovative Design",
      description:
        "Developing cutting-edge, customizable products that cater to diverse market needs with precision and creativity.",
    },
  ]

  

  
  const sectionRef = useRef(null);
  const triggerRef = useRef(null);
  const services = [
    {
      title: "Rudrapur, Uttarakhand",
      subtitle: "PAR FUE SAPHIR",
    },
    {
      title: "Bhiwadi, Rajasthan",
      subtitle: "PAR FUE SAPHIR",
    },
    {
      title: "Hyderabad, Telangana",
      subtitle: "PAR FUE SAPHIR",
    },
    {
      title: "Noida, Uttar Pradesh",
      subtitle: "PAR FUE SAPHIR",
    },
  ]
  
  const controls = useAnimation()
  const ref = useRef(null)
  const isInView = useInView(ref)


  const [hoveredIndex, setHoveredIndex] = useState(null)
    const jobs = [
      {
        title: 'Rudrapur, Uttarkhand',
        path: '/factory1', // Add the specific route
      },
      {
        title: 'Bhiwadi, Rajasthan',
        path: '/factory2',
      },
      {
        title: 'Hyderabad, Telangana',
        path: '/factory3',
      },
      {
        title: 'Noida, Uttar Pradesh',
        path: '/factory4',
      },
    ];
    const sections = [
        {
          title: 'Manufacturing Excellence',
          subtitle: 'Redefining quality and innovation',
          items: [
            {
              icon: <Shield className="w-6 h-6" />,
              title: 'Uncompromising Quality',
              description: 'Adhering to stringent quality standards and certifications, ensuring reliability and trust.',
              stat: '99.8%',
              statLabel: 'Product Reliability'
            },
            {
              icon: <Target className="w-6 h-6" />,
              title: 'Precision Craftsmanship',
              description: 'Utilizing advanced machinery and expert techniques for flawless manufacturing.',
              stat: '<0.2%',
              statLabel: 'Error Rate'
            },
            {
              icon: <Award className="w-6 h-6" />,
              title: 'Award-Winning Innovation',
              description: 'Recognized for groundbreaking designs and sustainable manufacturing practices.',
              stat: '25+',
              statLabel: 'Industry Awards'
            }
          ]
        },
        {
          title: 'Production Metrics',
          subtitle: 'Pioneering scalable solutions',
          items: [
            {
              icon: <Gauge className="w-6 h-6" />,
              title: 'Scalable Manufacturing',
              description: 'Capable of handling large-scale production without compromising on quality.',
              stat: '30M+',
              statLabel: 'Units Annually'
            },
            {
              icon: <Globe className="w-6 h-6" />,
              title: 'Global Operations',
              description: 'Delivering products across continents through a robust supply chain.',
              stat: '60+',
              statLabel: 'Countries Served'
            },
            {
              icon: <Cpu className="w-6 h-6" />,
              title: 'Technologically Advanced',
              description: 'Integrating AI and IoT for efficient and automated production workflows.',
              stat: '95%',
              statLabel: 'Automation Level'
            }
          ]
        }
      ];
    
      const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
          opacity: 1, 
          y: 0,
          transition: { duration: 0.6 }
        }
      };
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.8 }
      };
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
 
    const handleSubmit = (e) => {
        e.preventDefault();
        // Add your email submission logic here (e.g., API call)
        setSubmitted(true);
    };
    const [isHovered, setIsHovered] = useState(false);
   
    const containerRef = useRef(null);
 
    
    
 
 
   
    const navigate = useNavigate();

    const handleViewMore = (productName) => {
        switch (productName) {
          case 'Mobile':
            navigate('/mobile');
            break;
          case 'Laptop':
            navigate('/laptop');
            break;
          case 'Acer Tablet':
            navigate('/acer');
            break;
          case 'TWS':
            navigate('/tws');
            break;
          case 'Plastic Injection Moulding':
            navigate('/plastic');
            break;
          case 'Ac Idu & Odu Assembly':
            navigate('/ac')
            break;
          case 'LED TV':
            navigate('/led')
            break;
          case 'Smart Watch':
            navigate('/smartwatch');
            break;
          // Add more cases for other products as needed
          default:
            navigate('/'); // Fallback if product doesn't match
        }
      };
    const [productIndex, setProductIndex] = useState(0); // Track the first visible product
    const [isVisible, setIsVisible] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    setIsVisible(true);
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const stats = [
    {
      value: "500K+",
      label: "Units",
      sublabel: "Monthly Production Capacity",
      icon: <Factory className="w-6 h-6" />
    },
    {
      value: "ISO",
      label: "9001:2015",
      sublabel: "Quality Management System",
      icon: <Award className="w-6 h-6" />
    },
    {
      value: "100%",
      label: "Made in India",
      sublabel: "End-to-End Manufacturing",
      icon: <Target className="w-6 h-6" />
    },
    {
      value: "15+",
      label: "Product Lines",
      sublabel: "Advanced Technology Integration",
      icon: <Cpu className="w-6 h-6" />
    }
  ];
   
    
    const features = [
        {
          title: "Cost Leadership",
          description: "Key strength in maintaining low production costs by leveraging complete vertical integration, ensuring economies of scale, and optimizing manufacturing processes for high-volume production in Consumer Electronics.",
          image: main2,
          imageAlt: "Aircraft wing detail"
        },
        {
          title: "Advanced Manufacturing Technology",
          description: "Equipped with cutting-edge machinery and automation, our manufacturing facilities produce precision-engineered components that meet the most stringent industry standards.",
          image: main3,
          imageAlt: "Aircraft engine"
        },
        {
          title: "Innovative Product Design",
          description: "Combining functionality with aesthetics, our products are designed to meet the evolving needs of customers across industries. Each product embodies innovation, performance, and sustainability.",
          image: main4,
          imageAlt: "Full aircraft view"
        }
    ]
    const products = [
        { name: 'Mobile', image: Mobile, description: 'Latest smartphone with advanced features.'},
        { name: 'Acer Tablet', image: acer, description: 'A vibrant 4K LED TV for amazing visuals.' },
        { name: 'Plastic Injection Moulding', image: Plastic, description: 'Fast and efficient wireless charging solution.' },
        { name: 'Smart Watch', image: Smartwatch, description: 'Portable speaker with immersive sound.' },
        { name: 'TWS', image: TWS, description: 'Lightweight laptop with powerful performance.' },
        { name: 'Ac Idu & Odu Assembly', image: ac, description: 'Stylish smartwatch with health tracking.' },
        { name: 'LED TV', image:LED, description: 'Experience the next-gen gaming console.' },
        { name: 'Laptop', image: Laptop, description: 'Versatile tablet for work and entertainment.' },
    ];
 
    // Handle auto-scrolling every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setProductIndex((prevIndex) => (prevIndex + 1) % products.length);
        }, 3000); // Change every 3 seconds
 
        return () => clearInterval(interval); // Cleanup on unmount
    }, [products.length]);
 
    // Compute the visible products (3 at a time)
    const visibleProducts = [
        products[productIndex % products.length],
        products[(productIndex + 1) % products.length],
        products[(productIndex + 2) % products.length],
    ];
   
    const [imageSrc, setImageSrc] = useState(
        window.innerWidth >= 768 ? largeTimeline : smallTimeline
      );
    
      useEffect(() => {
        const handleResize = () => {
          setImageSrc(window.innerWidth >= 768 ? largeTimeline : smallTimeline);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
      // Intersection Observer


const [currentIndex, setCurrentIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? 1 : 0));
  }, 5000);
  return () => clearInterval(interval);
}, []);



const [currentSlide, setCurrentSlide] = useState(0);
const sliderRef = useRef(null);

const nextSlide = () => {
  setCurrentSlide((prev) => (prev >= divisions.length - 3 ? 0 : prev + 1));
};

const prevSlide = () => {
  setCurrentSlide((prev) => (prev <= 0 ? divisions.length - 3 : prev - 1));
};


const goToSlide = (index) => {
  setCurrentSlide(index);
};

const handleResize = () => {
  if (sliderRef.current) {
    const containerWidth = sliderRef.current.offsetWidth;
    const slideWidth = containerWidth / 3; // Assuming you want to show 3 slides
    const maxIndex = divisions.length - 3; // Calculate max index based on visible slides

    setCurrentSlide((prev) => Math.min(prev, maxIndex));
  }
};

useEffect(() => {
  window.addEventListener('resize', handleResize);
  handleResize(); // Call initially to set correct state

  return () => window.removeEventListener('resize', handleResize);
}, []);

    return (
        <div className="overflow-hidden">
   
   <div className="relative w-full h-screen overflow-hidden" >
      {images.map((src, index) => (
        <motion.img
          key={index}
          src={src}
          alt="Sliding Image"
          className="absolute w-full h-full object-cover"
          initial={{ y: "-100%", opacity: 0 }}
          animate={{ y: index === currentIndex ? "0%" : "-100%", opacity: index === currentIndex ? 1 : 0 }}
          transition={{ duration: 1 }}
        />
      ))}
    </div>

    <div className="relative  bg-white overflow-hidden">
  {/* Background Pattern */}
  <div
    className="absolute inset-0 z-0 opacity-10"
    style={{
      backgroundImage: `url('${process.env.NEXT_PUBLIC_BACKGROUND_URL || "https://www.glyphservices.com/wp-content/uploads/2020/04/Bubbles.png"}')`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  />

  {/* Content Container */}
  <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 md:py-32">
    {/* Main Content */}
    <div className="max-w-4xl">
      <h1 className="text-6xl md:text-6xl font-bold text-gray-900 mb-6">About BPL</h1>

      <div className="space-y-6 mb-20">
        <h2 className="text-4xl md:text-5xl text-orange-600">
          Bhagwati Products
          Private Limited
        </h2>
        <p className="text-gray-800 text-2xl leading-relaxed">
          has been leading the electronic manufacturing services (EMS) space in India.
        </p>
      </div>
    </div>

    {/* Secondary Content - Offset to the right */}
    <div className="max-w-3xl ml-auto">
      <p className="text-gray-700 text-xl leading-relaxed mb-6">
        As a homegrown manufacturing company, Dixon Technologies provides design-focused solutions in consumer
        durables, home appliances, lighting, mobile phones, and security devices to customers across the globe, along
        with repairing and refurbishment services of a wide range of products, including set-top boxes, mobile phones,
        and LED TV panels.
      </p>
      
    </div>
  </div>

  {/* Decorative Elements */}
  <div className="absolute top-0 right-0 w-64 h-64 md:w-128 md:h-128 bg-red-50 rounded-full -translate-y-1/2 translate-x-1/2 opacity-20" />
  <div className="absolute bottom-0 left-0 w-48 h-48 md:w-96 md:h-96 bg-red-50 rounded-full translate-y-1/2 -translate-x-1/2 opacity-20" />
</div>

    <div className="max-w-[1400px] mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row gap-12">
        {/* Left Content Section */}
        <div className="lg:w-1/2">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} >
            <h2 className="text-gray-500 uppercase tracking-wider mb-4">Legacy Meets Innovation            </h2>
            <h1 className="text-5xl font-bold leading-tight mb-8">
            Transforming Innovation, Manufacturing & Technology
            </h1>
            <p className="text-gray-600 text-lg max-w-2xl mb-16">
              Bhagwati Products Limited, is a proud collaboration between Micromax Informatics and Huaqin Technology Co., where we are shaping the future of innovation and manufacturing in India. Guided by a vision of manufacturing excellence and cutting-edge technology integration, we are committed to delivering world-class, Made-in-India products that cater to customers across the globe.
            </p>
            

          </motion.div>
        </div>

        {/* Right Images Section */}
        <div className="lg:w-1/2 relative">
          <div className="grid gap-6">
            <motion.div
              
             
              
              className="relative h-[500px] rounded-2xl overflow-hidden mt-10"
            >
              <img
                src={manu1}
                alt="Medical procedure 1"
                className="w-full h-full object-cover"
              />
            </motion.div>
           
          </div>
        </div>
      </div>
    </div>
     
      
      
    <div className="py-12" ref={sliderRef}> {/** Remove max-w-7xl and mx-auto, add padding to the section */}
      <div className="mx-auto px-4 max-w-7xl"> {/** Keep max-w-7xl and mx-auto in a new wrapper div */}
        <h2 className="text-5xl font-bold text-black mb-8">Our Divisions</h2>
        <p className="text-gray-600 mb-12">
          At BPL, our focus has always been on designing and developing
          best-in-class products for our customers across the globe along with
          expanding our product portfolio into newer verticals. We work closely
          with our customers, suppliers and other stakeholders to develop
          products that not only addresses new industry opportunities but also
          meets customer needs in an increasingly technology-dependent world
        </p>
        <div className="relative">
          {/* <button 
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-lg hover:bg-gray-100"
          >
            <ChevronRight className="w-6 h-6" />
          </button> */}

          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * (100/3)}%)` }} 
            >
              {divisions.map((division, index) => (
                <div 
                  key={index}
                  className="w-full flex-shrink-0 px-4 md:w-1/2 lg:w-1/3"
                >
                  <div className="bg-white p-6 rounded-lg border h-full hover:shadow-lg transition-shadow cursor-pointer" onClick={nextSlide}>
                    {division.icon}
                    <h3 className="text-xl font-semibold mb-3 text-center">{division.title}</h3>
                    <p className="text-gray-600 text-sm text-center">{division.description}</p>
                    <div className="text-center mt-4">
                      <Link to={division.link}>
                      <button className="text-orange-600 hover:text-blue-800 font-medium">
                        Read More
                      </button></Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <br></br>
          </div>

          {/* <div className="flex justify-center mt-6 gap-2">
            {divisions.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 rounded-full transition-colors duration-300 ${
                  currentSlide === index ? 'bg-orange-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div> */}
        </div>
      </div>
    </div>
   <main>
          <div className="mt-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Left side - Image and Stats */}
        <div className="relative">
          <img
            src={craftmanship}
            alt="Medical procedure demonstration"
            className="w-full rounded-lg"
          />

          {/* Overlapping stat cards */}
          <div className="absolute bottom-4 left-4 right-4 flex gap-4">
            {/* Innovation Card */}
            <div className="bg-gray-900 text-white rounded-lg p-6 shadow-xl flex-1">
              <div className="text-sm text-gray-200">Innovation at its Peak</div>
              <div className="text-4xl font-bold mb-1">6000+</div>
              <div className="text-xs text-gray-100">GREFFONS IN 2 DAYS</div>
            </div>

            {/* Craftsmanship Card */}
            <div className="bg-gray-900 text-white rounded-lg p-6 shadow-xl flex-1">
              <div className="text-sm text-gray-200">Masterful Craft</div>
              <div className="text-4xl font-bold mb-1">65+</div>
              <div className="text-xs text-gray-100">GREFFONS PER CM²</div>
            </div>
          </div>

        </div>

        {/* Right side - Content */}
        <div className="space-y-8">
          <div className="space-y-4">
            <div className="text-gray-600 uppercase tracking-wider text-sm">
              Innovation Meets Craftsmanship
            </div>

            <h1 className="text-4xl font-bold leading-tight">Blending Modern Innovation with Exceptional Craftsmanship</h1>

            <p className="text-gray-600 text-lg">
            Bhagwati Products Limited, established in 2002, is a leading Indian manufacturer of electronic and telecommunication devices. Our portfolio includes mobile phones, LED TVs, consumer electronics, batteries, and chargers. With over 40 million phones and 3 million TVs produced, we are committed to delivering cutting-edge technology and innovation.
            </p>
          </div>

          {/* Benefits list */}
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="mt-1 rounded-full bg-orange-500 p-1">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
              <span className="font-bold text-lg text-gray-800">Optimal Precision</span>
             
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="mt-1 rounded-full bg-orange-500 p-1">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
              <span className="font-bold text-lg text-gray-800">Natural Outcome</span>
              </div>
            </div>
          </div>

         
        </div>
      </div>
    </div>
    </main>
    
  
 

      </div>
   
    );
};
 
export default Home;
 